// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel-module--panel--3-Gkb","line":"panel-module--line--3xT46","left":"panel-module--left--3AvAm","right":"panel-module--right--11XJ2"};